import { Box, HStack, Text, VStack } from "@chakra-ui/react";
import { Link } from "@areahub/ui/components/link/link";
import { Fragment } from "react";
import { GenericAuthor } from "../types";
import { PostAuthorImage } from "./author-image";

export interface PostAuthorListProps<AuthorType extends GenericAuthor> {
  authors?: AuthorType[];
  meta?: string;
}

export const PostAuthorList = <AuthorType extends GenericAuthor>({
  authors,
  meta,
}: PostAuthorListProps<AuthorType>) => {
  return (
    <HStack>
      <HStack>
        {authors?.slice(0, 2).map((author) => {
          const url = `/individuals/knowledge-center/author/${author?.slug}`;

          return (
            <PostAuthorImage
              key={author?.slug}
              image={author?.photoPlaceholder}
              name={author?.person?.name || ""}
              url={url}
            />
          );
        })}
      </HStack>
      <VStack spacing="0">
        <Text w="100%">
          {authors?.map((author, i) => {
            const url = `/individuals/knowledge-center/author/${author?.slug}`;

            return (
              <Fragment key={author?.slug}>
                <Link
                  href={url}
                  fontWeight="semibold"
                  fontSize="md"
                  _hover={{
                    textDecoration: "underline",
                  }}
                >
                  {author.person?.name}
                </Link>
                {authors?.length > 2 ? i < authors?.length - 1 && ", " : " "}
                {i == authors?.length - 2 && "and "}
              </Fragment>
            );
          })}
        </Text>
        <Box fontSize="md" color="gray.500" w="100%">
          {meta}
        </Box>
      </VStack>
    </HStack>
  );
};
